module.exports = __webpack_public_path__ + "img/PREF_region_Pays_de_la_Loire_CMJN.607ef3c2.jpg";